import { ref } from 'vue';

export const eventBus = {
    curIndex: ref(0),

    updateCurIndex(index: number) {
        this.curIndex.value = index;
    }
};